/**
 * Activity 1 Date Summary page — backlink, DataTables, bulk actions.
 */
module.exports = function init_activity1_date_summary($) {

  const settings = (typeof mlmp_settings !== 'undefined') ? mlmp_settings : {};
  const back     = settings.a1_summary_back_link || null;
  const ds       = settings.a1_ds || {};

  // ── Backlink ────────────────────────────────────────────────────────────────

  const $backlink = $('#a1-year-summary-backlink');
  if ($backlink.length) {
    if (back && back.url && back.text) {
      $backlink.html('<a href="' + back.url + '" class="mlmp-back-link">&larr; ' + back.text + '</a>');
    } else {
      $backlink.hide();
    }
  }

  // ── Plants table — DataTables with pager and length menu ───────────────────

  const $plants_table = $('.a1-ds-plants-table');
  if ($plants_table.length && typeof $.fn.DataTable !== 'undefined') {
    const page_size  = parseInt(ds.default_page_size || 5, 10);
    const size_label = (ds.page_size_label || 'Page Size') + ': _MENU_';
    const sizes      = [5, 10, 20, 50, 100, 200, 500, 1000];

    $plants_table.DataTable({
      paging:      true,
      pageLength:  page_size,
      lengthMenu:  [sizes, sizes],
      info:        false,
      searching:   false,
      ordering:    true,
      dom:         '<"a1-ds-table-top"lp>t',
      language: {
        lengthMenu: size_label,
      },
      order: [[1, 'asc'], [$plants_table.find('thead tr.a1-subheader th').length - 1, 'desc']],
      columnDefs: [
        { orderable: false, targets: [0] },
      ],
    });
  }

  // ── Species totals table — sorting only, no paging ────────────────────────

  const $species_table = $('.a1-ds-species-table');
  if ($species_table.length && typeof $.fn.DataTable !== 'undefined') {
    $species_table.DataTable({
      paging:    false,
      info:      false,
      searching: false,
      ordering:  true,
    });
  }

  // ── Select all/none ─────────────────────────────────────────────────────────

  $(document).on('change', '.a1-ds-select-all', function () {
    const checked = $(this).prop('checked');
    $('.a1-ds-plant-check').prop('checked', checked);
  });

  $(document).on('change', '.a1-ds-plant-check', function () {
    const all_checked = $('.a1-ds-plant-check:not(:checked)').length === 0;
    $('.a1-ds-select-all').prop('checked', all_checked);
  });

  // ── Activity 1 data validation warnings ──────────────────────────────────────────────────────────

  const $template = $('.activity-1-date-summary');
  const warnings = $template.length ? ($template.data('warnings') || {}) : {};

  if (warnings.high_plant_count) {
    $('#a1-high-plant-count').addClass('is-active');
  }
  if (warnings.low_monitoring_time) {
    $('#a1-low-monitoring-time').addClass('is-active');
  }
  if (warnings.high_monarch_density) {
    $('#a1-high-monarch-density').addClass('is-active');
  }

  $(document).on('click', '.warning-dismiss', function () {
    $(this).closest('.modal-banner').removeClass('is-active');
  });

  // ── Bulk action bar ─────────────────────────────────────────────────────────

  $(document).on('change', '#a1-ds-bulk-action-select', function () {
    const val = $(this).val();
    $('.a1-ds-bulk-qty').prop('hidden', val !== 'duplicate_multiple');
  });

  $(document).on('click', '#a1-ds-bulk-submit', function () {
    const action = $('#a1-ds-bulk-action-select').val();
    if (!action) return;

    const ids = $('.a1-ds-plant-check:checked').map(function () {
      return $(this).closest('tr').data('plant-id');
    }).get().join(',');

    if (!ids) return;

    if (action === 'delete') {
      const count   = ids.split(',').length;
      const confirm_msg = (ds.bulk_delete_confirm || 'Delete {count} record(s)?').replace('{count}', count);
      if (!window.confirm(confirm_msg)) return;
    }

    $('#a1-bulk-action-value').val(action);
    $('#a1-bulk-plant-ids').val(ids);
    if (action === 'duplicate_multiple') {
      $('#a1-bulk-duplicate-count').val(parseInt($('#a1-ds-bulk-qty-input').val(), 10) || 1);
    }

    $('#a1-ds-bulk-form').submit();
  });

};
